
import { ref, defineComponent, computed, watch, reactive, toRaw } from 'vue'
import { useStore } from 'vuex'
import { mod, add } from '../request'
import { message } from 'ant-design-vue'
import { statusOptions } from '../config'
import BusinessFilter from '@/common/components/BusinessFilter.vue'
import ossUpload from '@/common/functions/ossUpload'

export default defineComponent({
    components: {
        BusinessFilter,
    },
    setup(props, { emit }) {
        const store = useStore()
        const formRef = ref()
        const detail = computed(() => store.state.msgauditApply.detail)
        interface Form {
            [key: string]: any
        }
        const form = reactive<Form>({
            corpId: '',
            corpName: '',
            mobile: null,
            status: null,
            applyName: null,
            applyCount: null,
            dealAmount: null,
            remark: '',
            realOpenCount: '',
            attachments: [],
        })
        const init = () => {
            let detailValue = detail.value
            if (detailValue) {
                Object.assign(form, {
                    corpId: detailValue.corpId,
                    corpName: detailValue.corpName,
                    mobile: detailValue.mobile,
                    status: detailValue.status,
                    applyName: detailValue.applyName,
                    applyCount: detailValue.applyCount,
                    dealAmount: detailValue.dealAmount,
                    remark: detailValue.remark,
                    realOpenCount: detailValue.realOpenCount,
                    attachments: JSON.parse(detailValue.attachments),
                })
            }
        }
        const rules = {
            corpId: [
                {
                    required: true,
                    message: '请输入商户名称',
                },
            ],
            mobile: [
                {
                    required: true,
                    message: '请输入手机号',
                },
            ],
            status: [
                {
                    required: true,
                    message: '请选择状态',
                    type: 'number',
                },
            ],
            applyName: [
                {
                    required: true,
                    message: '请输入申请人',
                },
            ],
            applyCount: [
                {
                    required: true,
                    message: '请输入申请会话数',
                    type: 'number',
                },
            ],
            realOpenCount: [
                {
                    required: true,
                    message: '请输入企微实际开通会话数',
                    type: 'number',
                },
            ],
        }
        const loading = ref<boolean>(false)
        const afterClose = () => {
            store.commit('toggleMsgauditApplyAddState', false)
            store.commit('setMsgauditApplyDetail', null)
        }
        const onSubmit = () => {
            formRef.value.validate().then(async () => {
                let formValue = toRaw(form)
                let params = {
                    ...form,
                    attachments: JSON.stringify(formValue.attachments),
                }
                let request = detail.value ? mod : add
                if (detail.value) {
                    Object.assign(params, {
                        id: detail.value.id,
                    })
                }
                loading.value = true
                try {
                    await request(params)
                } catch (e) {
                    loading.value = false
                }
                emit('success')
                message.success('保存成功')
                afterClose()
            })
        }
        function handleChange(info) {
            if (info.file.status === 'uploading') {
                loading.value = true
                return
            }
        }
        function removeAttachment(index) {
            form.attachments.splice(index, 1)
        }
        function changeBusinsess(event) {
            form.corpName = event.name
        }
        async function customUploadRequest(param) {
            let res: any = await ossUpload(param)
            let data = res.data
            loading.value = false
            form.attachments.push(data.url)
        }
        watch(detail, () => {
            init()
        })
        init()
        return {
            form,
            store,
            loading,
            rules,
            onSubmit,
            afterClose,
            statusOptions,
            detail,
            formRef,
            handleChange,
            removeAttachment,
            changeBusinsess,
            customUploadRequest,
        }
    },
})
